/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-03-08 00:00:00
 *
 *******************************************************/
// import _ from 'lodash';

import React, { Component } from 'react';
import { Modal, Card } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import { TEMPLATE_FEATURE } from 'src/constants/shopify-integration';

type Props = {};
type ComposedProps = Props & WithI18nProps;

type State = {};

class EnableWidgetFailModal extends Component<ComposedProps, State> {
  handleViewGuide = () => {
    const { selectedThemeId, templateId } = this.props;
    history.push(
      routes.shopifyIntegration.guide(selectedThemeId, templateId, TEMPLATE_FEATURE.ISW)
    );
  };

  render() {
    const { i18n, open, onClose, emailSupport } = this.props;

    return (
      <div>
        <Modal
          open={open}
          onClose={onClose}
          title={i18n.translate('AdminHTML.ShopifyIntegration.EnableWidgetFailModal.title')}
          primaryAction={[
            {
              content: i18n.translate('AdminHTML.ShopifyIntegration.Actions.viewGuide'),
              onAction: this.handleViewGuide
            }
          ]}
          secondaryActions={[
            {
              content: i18n.translate('AdminHTML.ShopifyIntegration.Actions.close'),
              onAction: onClose
            }
          ]}>
          {/* Content */}
          <div className="enable-widget-fail-modal">
            <Card>
              <Card.Section>
                <div className="content">
                  <p>
                    {i18n.translate(
                      'AdminHTML.ShopifyIntegration.EnableWidgetFailModal.description',
                      {
                        t: (
                          <b>
                            {i18n.translate(
                              'AdminHTML.ShopifyIntegration.EnableWidgetFailModal.description_t'
                            )}
                          </b>
                        )
                      }
                    )}
                  </p>
                  <br />
                  <p>
                    {i18n.translate('AdminHTML.ShopifyIntegration.EnableWidgetFailModal.note', {
                      mail: (
                        <span className="Polaris-Link" style={{ cursor: 'default' }}>
                          {emailSupport}
                        </span>
                      )
                    })}
                  </p>
                </div>
              </Card.Section>
            </Card>
          </div>
        </Modal>
      </div>
    );
  }
}

export default withI18n()(EnableWidgetFailModal);
